import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@mui/icons-material';
import { StyleSheet, css } from 'aphrodite';

const BackToHome = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/');
  };

  return (
    <span className={css(styles.backToHome)} onClick={handleNavigation}>
      <ArrowLeft /> Back to home
    </span>
  );
};

const styles = StyleSheet.create({
  backToHome: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.15rem',
    cursor: 'pointer',
    color: '#2783F7',
    fontWeight: '600',
    ':hover': {
      textDecoration: 'underline'
    }
  }
});

export default BackToHome;
